import * as React from 'react';

const AuthContext = /*#__PURE__*/ React.createContext({});
const AuthContextConsumer = ({ children  })=>/*#__PURE__*/ React.createElement(AuthContext.Consumer, null, (context)=>{
        if (!context || Object.keys(context).length === 0) {
            return /*#__PURE__*/ React.createElement("p", {
                className: "my-account--no-context"
            }, "Auth Provider missing in application.");
        }
        if (!context.enabled) {
            // TODO: instead redirect?
            return /*#__PURE__*/ React.createElement("p", {
                className: "my-account--not-enabled"
            }, "Auth not enabled in application.");
        }
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    })
;

export { AuthContextConsumer, AuthContext as default };
//# sourceMappingURL=AuthContext.js.map
